import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { range } from '../utils/utils';
import { AppInstance } from './appInstance';
function getGridSizeFromNumInstances(numInstances = 1) {
    if (numInstances > 2) {
        return {
            numColumns: 2,
            numRows: 2
        };
    }
    if (numInstances === 2) {
        return {
            numColumns: 1,
            numRows: 2
        };
    }
    return {
        numColumns: 1,
        numRows: 1
    };
}
function getGridSize() {
    const params = new URLSearchParams(window.location.search);
    if (params.has('num')) {
        return getGridSizeFromNumInstances(Number(params.get('num')));
    }
    return getGridSizeFromNumInstances();
}
export const AppInstanceGrid = () => {
    const { numColumns, numRows } = getGridSize();
    const widthRatio = 1 / numColumns;
    const heightRatio = 1 / numRows;
    const numInstances = numColumns * numRows;
    if (numColumns === 1 && numRows === 1) {
        return _jsx(AppInstance, { instanceId: 0, numInstances: numInstances, widthRatio: widthRatio, heightRatio: heightRatio });
    }
    return (_jsx("div", { css: css `
        display: flex;
        flex-direction: column;
      `, children: range(numRows).map((i) => {
            return (_jsx("div", { css: css `
              display: flex;
            `, children: range(numColumns).map((j) => (_jsx(AppInstance, { instanceId: i * numColumns + j, numInstances: numInstances, widthRatio: widthRatio, heightRatio: heightRatio }, j))) }, i));
        }) }));
};
